import React from "react";
import OneProduct from "../components/OneProduct";

const SingleProductPage = () => {
  return <OneProduct />;
};

export default SingleProductPage;
